import { useEffect } from 'react';
import { toast } from 'sonner';

/**
 * Listens for service worker update events and shows a toast
 * prompting the user to refresh.
 */
export function useServiceWorkerUpdate() {
  useEffect(() => {
    const handler = () => {
      toast('Update available', {
        description: 'A new version of Therappi is ready.',
        duration: Infinity,
        action: {
          label: 'Refresh',
          onClick: () => window.location.reload(),
        },
      });
    };

    window.addEventListener('therappi-sw-updated', handler);
    return () => window.removeEventListener('therappi-sw-updated', handler);
  }, []);
}
